
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/gaming",
      function () {
        return require("private-next-pages/qmee/gaming.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/gaming"])
      });
    }
  